import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "checkout-hotel-info-gallery" }
const _hoisted_2 = ["slides-per-view", "navigation"]
const _hoisted_3 = ["index"]
const _hoisted_4 = ["data-src", "alt", "onClick"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]

import { computed, ref, onActivated, useTemplateRef } from 'vue';
import { register } from 'swiper/element/bundle';
import type { HotelCatalogueImageType } from '@/interfaces/hotel-catalogue-types';
import { v4 as uuidv4 } from 'uuid';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import { type ClientType } from '@/interfaces/common';
import 'swiper/scss';
import GalleryModalWithGrid from '@lmt-rpb-new/molecules/GalleryModalNew/GalleryModalWithGrid.vue';
import { catalogueIconsIntoGalleryElements } from 'src/services/catalogueIcons';
import type { SwiperOptions } from 'swiper/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutHotelInfoGallery',
  props: {
    images: {},
    client: { default: 'at' },
    hotelName: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const uniqueId = 'id-' + uuidv4();
const swiperRef = ref<HTMLElement>();
const modalIndex = ref(0);
const gridModalRef = useTemplateRef('gridModalRef');

register();

const swiperOptions: SwiperOptions = {
	slidesPerView: 'auto',
	navigation: {
		nextEl: `#${uniqueId}-next`,
		prevEl: `#${uniqueId}-prev`,
	},
};

const imageArray = computed(() =>
	catalogueIconsIntoGalleryElements(Object.values(props.images), `© GIATA GmbH 1996 - ${new Date().getFullYear()}`)
);

const initializeSwiper = () => {
	if (!swiperRef.value) return;

	const swiperEl = swiperRef.value.querySelector('swiper-container');
	if (!swiperEl) {
		console.error('Swiper container not found');
		return;
	}

	swiperEl.initialize();
};

onActivated(() => {
	initializeSwiper();
});

const toggleGallery = (index: number) => {
	modalIndex.value = index;
	if (gridModalRef.value) {
		gridModalRef.value.openGalleryGridModal();
	}
};

const openGallery = (index: number) => toggleGallery(index);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "swiperRef",
      ref: swiperRef,
      class: "checkout-hotel-info-gallery__container-outer"
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("swiper-container", {
          "slides-per-view": swiperOptions.slidesPerView,
          navigation: swiperOptions.navigation,
          class: "checkout-hotel-info-gallery__container-inner"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, key, index) => {
            return (_openBlock(), _createElementBlock("swiper-slide", {
              key: key,
              index: index,
              class: "checkout-hotel-info-gallery__slide"
            }, [
              _createElementVNode("img", {
                class: "checkout-hotel-info-gallery__image rpb_lazy",
                "data-sizes": "auto",
                "data-src": image.URL,
                src: "data:image/gif;base64,R0lGODdhEgAMAIABAPD2/////ywAAAAAEgAMAAACDYSPqcvtD6OctNqLVQEAOw==",
                alt: `${image.Caption} - ${key}`,
                onClick: ($event: any) => (openGallery(index))
              }, null, 8 /* PROPS */, _hoisted_4)
            ], 8 /* PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_2)
      ]),
      _createElementVNode("div", {
        id: `${uniqueId}-next`,
        class: "swiper-button-next checkout-hotel-info-gallery__next-icon"
      }, [
        _createVNode(FaIcon, {
          class: "checkout-hotel-info-gallery__chevron-icon",
          icon: ['fa-solid', 'fa-chevron-right']
        })
      ], 8 /* PROPS */, _hoisted_5),
      _createElementVNode("div", {
        id: `${uniqueId}-prev`,
        class: "swiper-button-prev checkout-hotel-info-gallery__prev-icon"
      }, [
        _createVNode(FaIcon, {
          class: "checkout-hotel-info-gallery__chevron-icon",
          icon: ['fa-solid', 'fa-chevron-left']
        })
      ], 8 /* PROPS */, _hoisted_6)
    ], 512 /* NEED_PATCH */),
    _createVNode(GalleryModalWithGrid, {
      ref_key: "gridModalRef",
      ref: gridModalRef,
      "focused-index": modalIndex.value,
      "gallery-items": imageArray.value,
      "header-title": _ctx.hotelName
    }, null, 8 /* PROPS */, ["focused-index", "gallery-items", "header-title"])
  ]))
}
}

})